import type { WritableComputedRef } from 'vue'
// eslint-disable-next-line no-restricted-imports
import { computed, reactive, watch } from 'vue'
import { defineStore } from 'pinia'
import { getWindow } from '@/helpers/globals'

const getGtmVarStore = defineStore('gtmVars', () => {
    const gtmVars = reactive<Record<string, any>>({})

    return { gtmVars }
})

export function useGtmVar<TType extends string | boolean>(
    varName: string,
    initialValue?: TType
): WritableComputedRef<TType> {
    const window = getWindow()

    const { gtmVars } = getGtmVarStore()

    gtmVars[varName] ||= initialValue

    watch(
        () => gtmVars[varName],
        (newValue) => {
            if (newValue) {
                window?.dataLayer?.push({
                    [varName]: newValue,
                })
            }
        },
        { immediate: true }
    )

    return computed({
        get: () => gtmVars[varName],
        set: (newValue) => {
            gtmVars[varName] = newValue
        },
    })
}
